export enum AccountActionTypes {
  SET_ACCOUNT_DATA = "SET_ACCOUNT_DATA",
  SET_ACCOUNT_FORMADR_DATAVALUE = "SET_ACCOUNT_FORMADR_DATAVALUE",
}
